export const BANK_ACC_EXPENSE_PERIOD = 'BANK_ACC_EXPENSE_PERIOD';